import { useState, useEffect } from "react";
import "../styles/Formularios.css";
import "../styles/ReportesPorCategoria.css";
import ReporteSolicitudes from "./ReporteSolicitudes";
import ReporteBienes from "./ReporteBienes";
import ReporteUsuarios from "./ReporteUsuarios";
import ReporteBajas from "./ReporteBajas";
import ReporteInfra from "./ReporteInfra";
import { useGlobal } from "../context/ContenedorGlobal";
import RastrearRed from "./RastrearRed";

function ReportesPorCategoria() {

    const [vista, setVista] = useState("inicio"); // Estado para controlar qué vista mostrar
    const [filtroPrincipal, setFiltroPrincipal] = useState(null);
    const [error, setError] = useState("");

    // Estado para checkboxes de filtros
    const filtrosIniciales = {
        opcFolio: false,
        opcRangoFolios: false,
        opcFcreacion: false,
        opcFtermino: false,
        opcFcierre: false,
        opcTecnico: false,
        opcCategoria: false,
        opcEstado: false,
        opcFalla: false,
        opcSerie: false,
        opcUsuario: false,
        opcOperador: false,
        opcPalabra: false,
        opcRangoFechas: false,
        opcTodas: false
    };

    const [filtros, setFiltros] = useState(filtrosIniciales);

    // Diccionario de etiquetas para mostrar al usuario
    const etiquetas = {
        opcFolio: "Folio",
        opcRangoFolios: "Rango de Folios",
        opcFcreacion: "Fecha de Creación",
        opcFtermino: "Fecha de Término",
        opcFcierre: "Fecha de Cierre",
        opcTecnico: "Técnico",
        opcCategoria: "Categoría",
        opcEstado: "Estado",
        opcFalla: "Falla",
        opcSerie: "Serie del Bien",
        opcUsuario: "Usuario que reportó",
        opcOperador: "Usuario operador",
        opcPalabra: "Palabra clave",
        opcRangoFechas: "Rango de Fechas",
        opcTodas: "Todas las solicitudes"
    };

    // Reglas de habilitación/deshabilitación por cada opcion elegida, para que las consultas tengan sentido
    const reglas = {
        opcFolio: {
            deshabilita: [
                "opcFcreacion", "opcFcierre", "opcFtermino", "opcCategoria", "opcTecnico",
                "opcEstado", "opcFalla", "opcSerie", "opcUsuario", "opcOperador",
                "opcPalabra", "opcRangoFolios", "opcRangoFechas", "opcTodas"
            ]
        },
        opcFcreacion: {
            deshabilita: ["opcFolio", "opcFcierre", "opcFtermino", "opcRangoFolios", "opcRangoFechas", "opcTodas"]
        },
        opcFcierre: {
            deshabilita: ["opcFolio", "opcFcreacion", "opcFtermino", "opcRangoFolios", "opcRangoFechas", "opcTodas"]
        },
        opcFtermino: {
            deshabilita: ["opcFolio", "opcFcreacion", "opcFcierre", "opcRangoFolios", "opcRangoFechas", "opcTodas"]
        },
        opcCategoria: {
            deshabilita: ["opcFolio", "opcPalabra", "opcTodas"]
        },
        opcTecnico: {
            deshabilita: ["opcFolio", "opcPalabra", "opcTodas"]
        },
        opcEstado: {
            deshabilita: ["opcFolio", "opcFcierre", "opcFtermino", "opcPalabra", "opcTodas"]
        },
        opcFalla: {
            deshabilita: ["opcFolio", "opcPalabra", "opcTodas"]
        },
        opcSerie: {
            deshabilita: ["opcFolio", "opcFcreacion", "opcFcierre", "opcFtermino", "opcUsuario", "opcOperador", "opcPalabra", "opcTodas"]
        },
        opcUsuario: {
            deshabilita: ["opcFolio", "opcPalabra", "opcTodas"]
        },
        opcOperador: {
            deshabilita: ["opcFolio", "opcPalabra", "opcTodas"]
        },
        opcPalabra: {
            deshabilita: ["opcFolio", "opcTodas"]
        },
        opcRangoFolios: {
            deshabilita: [
                "opcFolio", "opcFcreacion", "opcFcierre", "opcFtermino",
                "opcSerie", "opcUsuario", "opcOperador", "opcRangoFechas", "opcTodas"
            ]
        },
        opcRangoFechas: {
            deshabilita: ["opcFolio", "opcFcreacion", "opcFcierre", "opcFtermino", "opcRangoFolios", "opcTodas"]
        },
        opcTodas: {
            deshabilita: [
                "opcFcreacion", "opcFcierre", "opcFtermino", "opcCategoria", "opcTecnico",
                "opcEstado", "opcFalla", "opcSerie", "opcUsuario", "opcOperador",
                "opcPalabra", "opcRangoFolios", "opcRangoFechas", "opcFolio"
            ]
        }
    };

    const handleChange = (campo) => {
        const nuevaConfig = { ...filtros };

        if (filtros[campo]) {
            // Si se desmarca un campo
            nuevaConfig[campo] = false;

            // Si era el filtro principal, se quita y se reestablece todo
            if (filtroPrincipal === campo) {
                setFiltroPrincipal(null);
                // Reinicia todos los filtros a su estado inicial
                Object.keys(nuevaConfig).forEach(opc => {
                    nuevaConfig[opc] = false;
                });
            }

        } else {
            // Activas el campo
            nuevaConfig[campo] = true;

            // Si aún no hay filtro principal, este se convierte en el principal
            if (!filtroPrincipal) {
                setFiltroPrincipal(campo);

                // Se aplican reglas de deshabilitación SOLO del principal
                if (reglas[campo]?.deshabilita) {
                    reglas[campo].deshabilita.forEach(opc => {
                        nuevaConfig[opc] = false;
                    });
                }
            }
            // Si ya existe un filtro principal, no se cambian las reglas
        }

        setFiltros(nuevaConfig);
    };

    // Función para limpiar los mensajes despues de un tiempo
    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError("");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    return (
        <div className="sesion-form">
            {vista === "inicio" && (
                <div className="reportes-botones form-buttons">
                    <button onClick={() => setVista("solicitudes")}>Solicitudes</button>
                    <button onClick={() => setVista("hardware")}>Hardware</button>
                    <button onClick={() => setVista("red")}>Red</button>
                    {/*<button onClick={() => setVista("software")}>Software</button>*/}
                </div>
            )}

            {vista === "solicitudes" && (

                <div>
                    {error && <div className="error">{error}</div>}
                    <h2>Selecciona los filtros:</h2>

                    <div className="filtros-container">
                        {Object.keys(filtros).map((campo) => {
                            const deshabilitado = filtroPrincipal
                                ? reglas[filtroPrincipal]?.deshabilita?.includes(campo)
                                : false;

                            return (
                                <label
                                    key={campo}
                                    className={deshabilitado ? "checkbox-disabled" : "checkbox-enabled"}
                                >
                                    <input
                                        type="checkbox"
                                        checked={filtros[campo]}
                                        onChange={() => handleChange(campo)}
                                        disabled={deshabilitado}
                                    />
                                    {etiquetas[campo]}
                                </label>
                            );
                        })}
                    </div>

                    <div className="form-buttons">
                        <button onClick={() => {
                            setVista("inicio");
                            setFiltros(filtrosIniciales);
                            setFiltroPrincipal(null);
                        }}>
                            Volver
                        </button>

                        <button onClick={() => {
                            setFiltros(filtrosIniciales);
                            setFiltroPrincipal(null);
                        }}>
                            Limpiar
                        </button>
                        <button
                            onClick={() => {
                                const algunFiltroActivo = Object.values(filtros).some(v => v === true);

                                if (!algunFiltroActivo) {
                                    setError("Debes seleccionar al menos un filtro antes de continuar.");
                                    return;
                                }

                                setError(""); // Limpia el error si todo está bien
                                setVista("reporteSolicitudes");
                            }}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            )}

            {vista === "reporteSolicitudes" && (
                <ReporteSolicitudes
                    filtros={filtros}
                    filtroPrincipal={filtroPrincipal}
                    setVista={setVista}
                />
            )}

            {vista === "hardware" && (
                <>
                    <div className="reportes-botones">
                        <button onClick={() => setVista("seccBienes")}>Bienes</button>
                        <button onClick={() => setVista("seccUsuarios")}>Usuarios</button>
                    </div>
                    <div className="form-buttons">
                        <button onClick={() => {
                            setVista("inicio");
                        }}>
                            Volver
                        </button>
                    </div>

                </>

            )}

            {vista === "seccBienes" && (
                <ReporteBienes setVista={setVista} />
            )}

            {vista === "seccUsuarios" && (
                <ReporteUsuarios setVista={setVista} />
            )}

            {vista === "red" && (
                <>
                    <div className="reportes-botones">
                        <button onClick={() => setVista("seccRastrearRed")}>Rastrear<br></br>red</button>
                        <button onClick={() => setVista("seccReporteInfra")}>Infraestructura</button>
                    </div>
                    <div className="form-buttons">
                        <button onClick={() => {
                            setVista("inicio");
                        }}>
                            Volver
                        </button>
                    </div>
                </>
            )}

            {vista === "seccRastrearRed" && (
                <>
                    <RastrearRed setVista={setVista} />
                    <div className="form-buttons">
                        <button onClick={() => {
                            setVista("red")
                        }}>
                            Volver
                        </button>
                    </div>
                </>
            )}

            {vista === "seccReporteInfra" && (
                <ReporteInfra setVista={setVista} />
            )}

            {vista === "software" && (
                <div>
                    <h2>Vista de Software</h2>
                    <p>Aquí irá el contenido de reportes de software.</p>
                    <button onClick={() => setVista("inicio")}>Volver</button>
                </div>
            )}

        </div>
    );
}

export default ReportesPorCategoria;